export const operatorValues = {
  contains: 'contains',
  dateRange: 'dateRange',
  dateRangePicker: 'dateRangePicker',
} as const;
